import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import OfferTable from './components/OfferTable'
import OfferForm from './components/OfferForm'

// Breadcrumbs
const crmBreadcrumb: PageLink = {title: 'CRM', path: '/', isSeparator: false, isActive: false}
const crmOfferBreadcrumb: PageLink = {
  title: 'Offer',
  path: '/crm/offer',
  isSeparator: false,
  isActive: true,
}

function OfferPage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Offer</PageTitle>
              <OfferTable />
            </>
          }
        />

        <Route
          path='/add'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmOfferBreadcrumb]}>Add Offer</PageTitle>
              <OfferForm />
            </>
          }
        />

        <Route
          path='/edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmOfferBreadcrumb]}>Edit Offer</PageTitle>
              <OfferForm />
            </>
          }
        />
      </Route>

      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default OfferPage
